module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-65.40bbba76.svg";